import { render, staticRenderFns } from "./MonitorDetails.vue?vue&type=template&id=6477d466"
import script from "./MonitorDetails.vue?vue&type=script&lang=js"
export * from "./MonitorDetails.vue?vue&type=script&lang=js"
import style0 from "./MonitorDetails.vue?vue&type=style&index=0&id=6477d466&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports